export const PARAPLANNING_ASSIGNED_TO_OPTIONS = [
  {
    value: "luke.onuoha@rosemountfs.co.uk",
    label: "Luke Onuoha",
    email: "luke.onuoha@rosemountfs.co.uk",
    categories: ["FP"],
  },
  {
    value: "hamza.nazir@rosemountfs.co.uk",
    label: "Hamza Nazir",
    email: "hamza.nazir@rosemountfs.co.uk",
    categories: ["FP"],
  },
  {
    value: "siddharth.nakul@rosemountfs.co.uk",
    label: "Siddharth Nakul",
    email: "siddharth.nakul@rosemountfs.co.uk",
    categories: ["MA"],
  },
  {
    value: "chloe.denovan@rosemountfs.co.uk",
    label: "Chloe Denovan",
    email: "chloe.denovan@rosemountfs.co.uk",
    categories: ["MA"],
  },
  {
    value: "jacko.lam@rosemountfs.co.uk",
    label: "Jacko Lam",
    email: "jacko.lam@rosemountfs.co.uk",
    categories: ["FP"],
  },
  {
    value: "george.taylor@rosemountfs.co.uk",
    label: "George Taylor",
    email: "george.taylor@rosemountfs.co.uk",
    categories: ["FP"],
  },
  {
    value: "elliot.burley@rosemountfs.co.uk",
    label: "Elliot Burley",
    email: "elliot.burley@rosemountfs.co.uk",
    categories: ["FP"],
  },
  {
    value: "davin.thomas@rosemountfs.co.uk",
    label: "Davin Thomas",
    email: "davin.thomas@rosemountfs.co.uk",
    categories: ["FP"],
  },
];
